import { apiService } from "api/apiService";
import type {
  AssessableTasksResource,
  AssessedTasksResource,
  FilterResource,
} from "api/generated";
import type { PaginatedResponse, PaginatedResult } from "api/types";
import { mapPaginatedResponse } from "api/mappers/pagination.mapper";
import { assessableTaskFromDto } from "portfolio/api/mappers";
import { mapFilters } from "shared/mappers";
import type { Filter } from "shared/types";
import type { AssessableTask } from "portfolio/types";

export const fetchPendingAssessments = async (
  params: Record<string, string> = {},
): Promise<PaginatedResult<AssessableTask>> => {
  const { data } = await apiService.get<
    PaginatedResponse<AssessableTasksResource>
  >("api/portfolio/assessments/open", { params });

  return mapPaginatedResponse(data, assessableTaskFromDto);
};

export const fetchPendingAssessmentFilters = async (): Promise<Filter[]> => {
  const {
    data: { data: filters },
  } = await apiService.get<{ data: FilterResource[] }>(
    "api/portfolio/assessments/open/filters",
  );

  return mapFilters(filters);
};

export const fetchReviewedAssessments = async (
  params: Record<string, string> = {},
): Promise<PaginatedResult<AssessableTask>> => {
  const { data } = await apiService.get<
    PaginatedResponse<AssessedTasksResource>
  >("api/portfolio/assessments/reviewed", { params });

  return mapPaginatedResponse(data, assessableTaskFromDto);
};

export const fetchReviewedAssessmentFilters = async (): Promise<Filter[]> => {
  const {
    data: { data: filters },
  } = await apiService.get<{ data: FilterResource[] }>(
    "api/portfolio/assessments/reviewed/filters",
  );

  return mapFilters(filters);
};
